// Provides the global jQuery that jquery-slimscroll expects. Must be imported
// before any code that pulls in a jQuery plugin. Replaces webpack ProvidePlugin.
import jquery from 'jquery';

window.$ = jquery;
window.jQuery = jquery;
